import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-phone-input-2/lib/bootstrap.css"; // phone input styles
import "../styles/Login.css";
import reactLogo from "../assets/policy-logo.png";
import PhoneInput from "react-phone-input-2"; // flag phone input
import AnimatedBanner from "../components/AnimatedBanner";
import { sendOtp } from "../services/OtpVerification";
import CONFIG from "../utils/config";

const Login = () => {
  const [qid, setQid] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [policyNumber, setPolicyNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedIdType, setSelectedIdType] = useState("QID");
  const [isChecked, setIsChecked] = useState(false);
  const navigate = useNavigate();

  const handleCheckboxChange = (e) => setIsChecked(e.target.checked);

  const generateOTP = () => {
    const otpLength = 6;
    let otpValue = "";
    for (let i = 0; i < otpLength; i++) {
      otpValue += Math.floor(Math.random() * 10);
    }
    setOtp(otpValue);
    toast.success("OTP generated!", { position: "top-right", autoClose: 2000 });
  };

  const handleSendOtp = async (phoneNo, otp) => {
  try {
    // --- Choose axios or fetch ---
    // const result = await sendOtpWithAxios(phoneNo, otp);
    const result = await sendOtp(phoneNo, otp);

    toast.success("OTP sent successfully!");
    console.log("SMS API Response:", result);
  } catch (err) {
    toast.error("Failed to send OTP");
    console.error("SMS API Error:", err);
  }
};


  const formatMobileNumberForComparison = (mobile) => {
    return mobile.replace(/\s/g, "").replace(/-/g, "");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (
      (selectedIdType === "QID" && !qid.trim()) ||
      (selectedIdType === "Policy Number" && !policyNumber.trim()) ||
      !mobileNumber ||
      mobileNumber.length < 8
    ) {
      toast.error("Please enter a valid QID / Policy Number and Mobile Number!", {
        position: "top-right",
        autoClose: 2000,
      });
      return;
    }
  
    setLoading(true);
  
    try {
      let requestBody = { mobileNumber };
      if (selectedIdType === "QID") requestBody.qid = qid;
      else requestBody.policyNumber = policyNumber;
  
      const response = await fetch(`${CONFIG.BASE}/insurance/fetch`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });
  
      if (!response.ok) throw new Error(`Failed to fetch policy details. Status: ${response.status}`);
  
      const userPolicy = await response.json();
  
      // Optional: normalize mobile number for comparison
      const enteredMobileFormatted = mobileNumber.replace(/\s/g, "").replace(/-/g, "");
      const storedMobileFormatted = (userPolicy.mobileNumber || "").replace(/\s/g, "").replace(/-/g, "");
  
      if (enteredMobileFormatted !== storedMobileFormatted) {
        toast.error("Mobile number does not match the policy record!", { position: "top-right", autoClose: 2000 });
        setLoading(false);
        return;
      }
  
    

      if (userPolicy.policyStatus === "POLICY_ALREADY_AVAILABLE") {
        toast.success("Policy is already available!", { position: "top-right", autoClose: 2000 });
        navigate("/success", { state: { id: userPolicy.id } });
    } else if (userPolicy.proposalStatus === "PROPOSAL_FAILURE") {
     
      toast.error("Proposal generation failed. Please contact support.");
      navigate("/");
  } else if (userPolicy.policyStatus === "POLICY_NOT_GENERATED_CAN_RENEW") {
    toast.info("Proceed for renewal.", { position: "top-right", autoClose: 2000 });
        navigate("/motor", { state: { id: userPolicy.id } });
    } else {
        toast.warning("Unknown policy status. Please contact support.");
    }
  
    } catch (error) {
      console.error("Error fetching policy details:", error);
      toast.error("Error fetching policy details. Please try again!", { position: "top-right", autoClose: 2000 });
    }
  
    setLoading(false);
  };
  

  return (
    <div className="container-fluid login-container overflow-hidden">
      <div className="row d-flex justify-content-center align-items-center min-vh-100">
        <div className="col-sm-12">
          <a
            className="d-flex justify-content-center align-items-center mb-4 text-decoration-none"
            href="/"
          >
            <img
              className="me-2 react-logo"
              src={reactLogo}
              alt="QIC Logo"
              width="160"
              height="80"
            />
          </a>
          <AnimatedBanner />
          <div className="card animated-card">
            <div className="card-body p-4 p-sm-5">
              <h5 className="text-center mb-4 fw-bold">
                <span
                  className="font-sans-serif text-decoration-none fw-bolder fs-4"
                  style={{ color: "#1d2671" }}
                >
                  <span style={{ color: "#c33764" }}>OneClick</span> Policy Renewal
                </span>
              </h5>
              <form onSubmit={handleSubmit}>
                {/* Radio buttons */}
                <div className="d-flex justify-content-evenly align-items-center mb-3">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      checked={selectedIdType === "QID"}
                      onChange={() => setSelectedIdType("QID")}
                    />
                    <label className="form-check-label">QID</label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      checked={selectedIdType === "Policy Number"}
                      onChange={() => setSelectedIdType("Policy Number")}
                    />
                    <label className="form-check-label">Policy Number</label>
                  </div>
                </div>

                {/* QID or Policy Number */}
                <div className="mb-3">
                  <input
                    className="form-control"
                    type="text"
                    placeholder={selectedIdType === "QID" ? "xxxxxxxxxxx" : "xxxxxxxx"}
                    value={selectedIdType === "QID" ? qid : policyNumber}
                    onChange={(e) =>
                      selectedIdType === "QID"
                        ? setQid(e.target.value)
                        : setPolicyNumber(e.target.value)
                    }
                  />
                </div>

                {/* Mobile number with flag */}
                <div className="mb-3">
                  <PhoneInput
                    country={"qa"} // default Qatar
                    value={mobileNumber}
                    onChange={(phone) => setMobileNumber(`+${phone}`)}
                    inputProps={{
                      name: "mobile",
                      required: true,
                      autoFocus: false,
                    }}
                    enableSearch={true}
                    countryCodeEditable={false}
                  />
                </div>

                {/* OTP */}
                <div className="input-group mb-3">
                  <input
                    className="form-control"
                    type="password"
                    placeholder="OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                  />
                  <button
                    className="btn btn-outline-danger fw-semibold"
                    type="button"
                    onClick={generateOTP}
                    // onClick={handleSendOtp}
                  >
                    Get OTP
                  </button>
                </div>

                {/* Terms */}
                <div className="form-check">
                  <input
                    className="form-check-input border-2 border-dark"
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                  <label className="form-check-label">I Agree to Terms & Conditions</label>
                </div>

                {/* Submit */}
                <div className="mb-3">
                  <button
                    className="btn renewal-opt__btn-primary d-block w-100 mt-3"
                    type="submit"
                    disabled={!isChecked || loading}
                  >
                    {loading ? <span className="spinner-border spinner-border-sm"></span> : "Get Policy"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
